const GetStarted = () => {
    
    const scrollToCitizens = () => {        
        document.querySelector("#comunidad").scrollIntoView({
            behavior: 'smooth'
        })
    }

    const scrollToCompanies = () => {
        document.querySelector("#comunidad").scrollIntoView({
            behavior: 'smooth'
        })
    }

    return (
        <section className="App-section" id="empezar">
            <h2>Empieza a usar Calpecoin</h2>
            <div className="App-cards-row" onClick={scrollToCitizens}>
                <div className="App-card card-people">
                    <div className="App-get-started-card-title">
                        <h3>Ciudadanos</h3>
                    </div>
                    <div className="App-get-started-card-content">
                        <ul>
                            <li>Envía CALP a amigos y familiares</li>
                            <li>Recibe recompensas por ayudar a proteger la red</li>
                            <li>Ayuda a construir el ecosistema descentralizado de Calpe</li>
                            <li>Participa en eventos locales</li>
                            <li>Crea o vota propuestas para la comunidad</li>
                        </ul>
                    </div>
                </div>
                <div className="App-card" onClick={scrollToCompanies}>
                    <div className="App-get-started-card-title">
                        <h3>Empresas</h3>
                    </div>
                    <div className="App-get-started-card-content">
                        <ul>
                            <li>Atrae clientes locales</li>
                            <li>Ayuda a proteger la red, recibe recompensas y reconocimiento local</li>
                            <li>Lidera el futuro de la economía descentralizada de Calpe</li>
                            <li>Patrocina eventos locales</li>
                            <li>Construye servicios sobre Calpecoin</li>
                        </ul>
                    </div>                    
                </div>
            </div>
        </section>
    )
}

export default GetStarted